import { styled } from '@mui/material/styles';

const StyledFlag = styled('img')`
  width: 24px;
  height: auto;
  margin-right: 16px;
`;

export default StyledFlag;
